export enum LotStatusEnum{
    OPEN = 'OPEN',
    ASSIGNED = 'ASSIGNED'
}